import ReactDOMServer from 'react-dom/server';
import _pick from 'lodash/pick';

/**
 * Format Form fields in preparation for calling a mutation.
 * @param {*} formLayout: an ordered list - required for all ids
  [
    { fieldType: 'header', id: 'contactInfo' },
    { fieldType: 'input', id: 'firstName' },
  ]
 * @param {*} formInputs: a mapping of id to value - required for all ids
  {
    contactInfo: "Contact Info",
    firstName: "Gemma"
  }
 * @param {*} validatorData: a mapping of textinputvalidator props - optional (encouraged)
  {
    firstName: {
      componentType: 'TextInput',
      validators: ['required'],
      floatingLabelText: 'First name*',
    },
  }
 */
export const formatFormFieldsForMutation = (
  formLayout,
  formInputs,
  validatorData = {},
) => {
  return formLayout.reduce((acc: any, field, index) => {
    const { fieldType, id: fieldId } = field;
    const formObj = { index };
    if (fieldType === 'header') {
      formObj.headerLabel = formInputs[fieldId];
    } else {
      // fieldType is input.
      const val = _pick(validatorData[fieldId], [
        'componentType',
        'validators',
        'staticLabelText',
        'floatingLabelText',
      ]);

      // Strip out any html styling of the label; convert jsx to html and then strip :-/
      const fieldLabel = val.staticLabelText
        ? val.staticLabelText
        : val.floatingLabelText;
      const staticMarkup = ReactDOMServer.renderToStaticMarkup(fieldLabel);
      const strippedHTML = staticMarkup.replace(/<[^>]+>/g, '');

      formObj.componentType = val.componentType;
      formObj.fieldLabel = strippedHTML;
      formObj.fieldInput = formInputs[fieldId]
        ? formInputs[fieldId].toString().trim()
        : '';
      if (val.validators) {
        formObj.validators = val.validators;
      }
    }
    acc[fieldId] = formObj;
    return acc;
  }, {});
};
